<div class="mb-3 mt-2">
    <div id="botones" class="mb-3 justify-content-between ms-2">
        @if(documentoObtenido?.id) {
            <button styleSheetFile="assets/css/print.css,assets/css/bootstrap.min.css"
            printTitle="{{this.documentoObtenido.prefijo}}-{{this.documentoObtenido.numeroComprobante}} {{this.documentoObtenido.fechaHoraCreacion}}"
            printSectionId="invoicingPrint" useExistingCss="true" class="btn btn-sm btn-outline-secondary ms-2 mt-1" ngxPrint>
            <i class="fa fa-print" aria-hidden="true"></i> Imprimir
            </button>
        }

        <button type="button" [disabled]="documentoObtenido.factura?.remitos?.length === 0"
            class="btn mt-1 btn-sm btn-outline-success mx-2" (click)="exportarRemito(documentoObtenido)">
            <i class="fa fa-file-excel-o" aria-hidden="true"></i> Exportar remitos
        </button>

        <button type="button" class="btn mt-1 btn-sm btn-outline-danger" (click)="verImpuestos()">
            Ver impuestos
        </button>

        @if(showCupones) {
            <button
            type="button" class="btn mt-1 btn-sm btn-outline-warning ms-2" (click)="verCupones()">
            Ver cupones
            </button>
        }

        @if(!this.documentoObtenido.factura?.linkPDFOriginal) {
            <button class="btn mt-1 btn-sm btn-outline-primary ms-2"       
            (click)="descargarComprobante(documentoObtenido)" >
            @if(!descargando) { 
                <span>Descargar comprobante</span> 
            } @else if (descargando) {
                <div class="d-flex align-items-center">
                    <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                    <span>Descargando...</span>
                </div>
            }
            </button>
        }

        @if(documentoObtenido.factura?.linkPDFOriginal) {
            <a [href]="this.documentoObtenido.factura.linkPDFOriginal">
            <button class="btn mt-1 btn-sm btn-outline-primary ms-2">
                <span>Descargar comprobante original</span>
            </button>
            </a>
        }

        @if(documentoObtenido?.id) {
            <button class="btn mt-1 btn-sm btn-outline-primary ms-2" (click)="reenviarCorreo()">
            @if(!reenviando) { 
            <span>Reenviar comprobante por correo</span>
            } @else if (reenviando) {
                <div class="d-flex align-items-center">
                <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                <span>Reenviando...</span>
                </div>
            }
            </button>
        }
    </div>
</div>